import React, { useEffect, useState } from "react";
import DashboardFooter from "../Footer/DashboardFooter";
import DashboardLeftMenu from "./DashboardLeftMenu";
import DashboardHeader from "../Header/DashboardHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlusCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Axios from "../../axios/Axios";
import { HOST_URL } from "./api/Api";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DeleteModal from "./campaign/Rcs/DeleteModal";

const WorkflowList = () => {
    const history = useHistory();
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;

    const [searchFlow, setSearchFlow] = useState("");
    const [workFlowList, setWorkFlowList] = useState([]);
    const [openPopup, setopenPopup] = useState(false)
    const [id, setId] = useState("");
    const [error, setError] = useState({
        errorStatus: false,
        bgColor: "",
        errorMessage: "",
    });

    useEffect(() => {
        getWorkflowData();
    }, []);

    const getWorkflowData = async () => {
        const payload = {
            user_id,
            token,
            method: "retrieve",
        };

        const { data } = await Axios.post(
            `${HOST_URL}/webhook_reciever.php`,
            payload
        );

        if (data.success) {
            setWorkFlowList(data.data);
        }
    };

    const handleStatusChange = async (id) => {
        const current = workFlowList.find((i) => i.id === id);
        if (!current) return;

        const newStatus = current.status === 1 ? 0 : 1;

        // Optimistic UI
        setWorkFlowList((prev) =>
            prev.map((i) =>
                i.id === id ? { ...i, status: newStatus } : i
            )
        );

        try {
            const payload = {
                user_id,
                token,
                method: "update_status",
                id,
                status: newStatus,
            };

            const { data } = await Axios.post(
                `${HOST_URL}/webhook_reciever.php`,
                payload
            );

            if (!data.success) throw new Error();
        } catch {
            // rollback
            setWorkFlowList((prev) =>
                prev.map((i) =>
                    i.id === id ? { ...i, status: current.status } : i
                )
            );
        }
    };

    const openDeletePopup = (id) => {
        setopenPopup(true)
        setId(id)
    }

    const CloseDeleteModal = () => {
        setopenPopup(false)
    }

    const DeleteWorkflow = async () => {
        let paramData = {
            user_id,
            token,
            method: "delete",
            id: id
        }
        try {
            let { data } = await Axios.post(`${HOST_URL}/webhook_reciever.php`, paramData)
            if (data.success) {
                // console.log(data);
                setopenPopup(false)
                setId("");
                setError({
                    errorStatus: true,
                    bgColor: "alert alert-success",
                    errorMessage: data.message,
                });
                getWorkflowData();
            }
            else {
                setError({
                    errorStatus: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message,
                });
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: "alert alert-danger",
                errorMessage: error.data.message,
            });
        }
    }

    return (
        <div className="wrapper">
            <DashboardLeftMenu />

            <div className="main bg-light min-vh-100">
                <DashboardHeader />

                <main className="content">
                    <div className="container-fluid">

                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="fw-bold">Your Workflows</h4>
                            <button
                                className="btn btn-info"
                                onClick={() => history.push("/dashboard/workflow")}
                            >
                                <FontAwesomeIcon icon={faPlusCircle} /> Create Workflow
                            </button>
                        </div>
                        {error.errorStatus && (
                            <div className={error.bgColor} role="alert">
                                {/* <button
                                            type="button"
                                            className="close"
                                            data-dismiss="alert"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button> */}
                                <div>{error.errorMessage}</div>
                            </div>
                        )}

                        {/* Search */}
                        <div className="mb-3">
                            <input
                                className="form-control"
                                placeholder="Search by workflow name..."
                                value={searchFlow}
                                onChange={(e) => setSearchFlow(e.target.value)}
                            />
                        </div>

                        {/* Table */}
                        <div className="table-responsive bg-white rounded shadow-sm">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Status / Date</th>
                                        <th>Application</th>
                                        <th>Workflow Name</th>
                                        <th>Event</th>
                                        <th className="text-end">Task Consumption</th>
                                        <th className="text-end">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {workFlowList
                                        .filter((i) =>
                                            i.list_name.toLowerCase().includes(searchFlow.toLowerCase())
                                        )
                                        .map((item) => (
                                            <tr key={item.id}>
                                                {/* Status */}
                                                <td>
                                                    <span
                                                        className={`badge ${item.status === 1 ? "bg-success" : "bg-danger"
                                                            }`}
                                                    >
                                                        {item.status === 1 ? "Active" : "Inactive"}
                                                    </span>
                                                    <div className="small text-muted mt-1">
                                                        {item.created_at}
                                                    </div>
                                                </td>

                                                {/* Application */}
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <i className={`${item.icon} text-primary me-2`} />
                                                        <strong>{item.platform_name || "App"}</strong>
                                                    </div>
                                                </td>

                                                {/* Workflow */}
                                                <td>
                                                    <Link
                                                        to={`/dashboard/workflow-edit/${item.id}`}
                                                        className="fw-semibold text-decoration-none d-block"
                                                    >
                                                        {item.list_name}
                                                    </Link>
                                                    <div className="small text-muted">Home</div>
                                                </td>
                                                <td>{item.event_name}</td>

                                                {/* Task Consumption */}
                                                <td className="text-end">
                                                    <div className="fw-semibold">0 Tasks Consumed</div>
                                                    <div className="small text-muted">
                                                        0 Free Tasks Consumed
                                                    </div>
                                                </td>

                                                {/* Actions */}
                                                <td className="text-end">
                                                    <div className="d-inline-flex align-items-center gap-3">
                                                        <label className="switch mb-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={item.status === 1}
                                                                onChange={() => handleStatusChange(item.id)}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>

                                                        <Link to={`/dashboard/workflow-edit/${item.id}`}>
                                                            <FontAwesomeIcon
                                                                icon={faPen}
                                                                className="text-muted ml-3"
                                                            />
                                                        </Link>

                                                        <span style={{ cursor: "pointer" }}>
                                                            <FontAwesomeIcon
                                                                icon={faTrashAlt}
                                                                onClick={() => openDeletePopup(item.id)}
                                                                className="text-muted ml-3"
                                                            />
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>


                    </div>
                    <DeleteModal show={openPopup} onClose={CloseDeleteModal} onDelete={DeleteWorkflow} />
                </main>

                <DashboardFooter />
            </div>
        </div>
    );
};

export default WorkflowList;
